import React, { useState } from "react";
import { printFullDateTime } from "../utils/time";
import { description } from "../utils/ar";
import { getOptionSingleText } from "../utils/objects";
import { sessionOptionsRate } from "../services/contentServices";
import SessionRateCard from "../components/form/SessionRateCard";
import auth from "../services/authServices";
import http from "../services/httpServices";
import modal from "../services/modalServices";
import { useLanguage } from "../context/LanguageContext";

const LiveSessionUserAttendanceCard = ({ session = {}, handleAfterSuccess = () => null }) => {
    const [data, setData] = useState({
        live_session_user_rating: "",
        live_session_user_comment: "",
    });
    const { language } = useLanguage();

    const content = {
        sessionDate: {
            en: "Session Date",
            ar: "كان معاد الجلسة",
        },
        sessionTitle: {
            en: "Session Title:",
            ar: "عنوان الجلسة :",
        },
        sessionDetails: {
            en: "Session Details:",
            ar: "تفاصيل الجلسة :",
        },
        attendanceStatus: {
            en: "Attendance Status:",
            ar: "حالة الحضور:",
        },
        pendingAttendance: {
            en: "Your attendance status is not yet recorded.",
            ar: "لم يتم تحديد حالة حضورك بعد",
        },
        attendedSession: {
            en: "You attended the session.",
            ar: "حضرت الجلسة",
        },
        missedSession: {
            en: "You missed the session.",
            ar: "كنت غايب عن الجلسة",
        },
        yourRating: {
            en: "Your Rating for the Teacher:",
            ar: "تقيمك للمدرس:",
        },
        assistantTeacher: {
            en: "Assistant Teacher:",
            ar: "المدرس المٌساعد:",
        },
        teacherRating: {
            en: "Teacher's Rating for You:",
            ar: "تقيم المدرس ليك:",
        },
        ratingDate: {
            en: "Rating Date:",
            ar: "تاريخ التقييم :",
        },
        teacherComment: {
            en: "Teacher's Comment:",
            ar: "ملاحظة المدرس:",
        },
        waitingForSupervisor: {
            en: "Waiting for the supervisor to record your attendance so you can rate the session.",
            ar: "في انتظار تسجيل بياناتك من قبل المشرف عشان تقدر تقيم الجلسة",
        },
        cannotRate: {
            en: "Unfortunately, you missed this session, so you cannot rate it.",
            ar: "للأسف انت غيبت في الجلسة دي , مش هتقدر تقيمها",
        },
        successMessage: {
            en: "Successfully Rated",
            ar: "تم التقييم بنجاح",
        },
    };
    const handleRateSession = async (live_session_user_attendance_id) => {
        const token = auth.getToken();
        const config = auth.getAuthConfig(token);
        try {
            const { data: response } = await http.post(
                `/api/live_sessions/live_session_user_attendances/${live_session_user_attendance_id}/rate_session`,
                data,
                config
            );
            modal.message({
                title: content.successMessage[language],
                text: response.message,
                callback: () => {
                    handleAfterSuccess();
                },
            });
        } catch ({ response }) {
            // console.log(response);
        }
    };
    return (
        <div
            className="bg-ashGray-100 px-4 space-y-10 flex items-center flex-col max-w-[350px] py-5 justify-evenly min-h-[350px] dark:bg-secYellow-200 smooth rounded-xl border-[.5px] border-black"
            key={session.id}
        >
            <div className="w-3/4 flex clr-text-primary smooth flex-col gap-2 ">
                <h3 className="font-bold  text-center w-full text-lg mb-2 flex-center-both flex-col">
                    <div className="text-blueMonq-800 smooth"> {content.sessionDate[language]}</div>
                    <div>{printFullDateTime(session.live_session.session_date, language)}</div>
                </h3>
                <p>
                    <label>{content.sessionTitle[language]}</label>
                    {session.live_session.name}
                </p>
                <p>
                    <label>{content.sessionDetails[language]}</label>
                    {description(session.live_session.description, true)}
                </p>
                {session.attendance_status === "attended" &&
                session.live_session_user_rating !== null ? (
                    <div className="py-3 px-2 flex-center-both flex-col space-y-5 bg-ashGray-800 dark:bg-ashGray-200 smooth clr-text-primary rounded-md border-[.5px] shadow-md border-black">
                        <div className="flex-center-both flex-col space-y-3">
                            <div className="flex gap-2 w-full">
                                <label>{content.attendanceStatus[language]}</label>
                                {session.attendance_status === "pending" ? (
                                    <span className="text-ashGray-500 w-1/2 text-center ">
                                        {content.pendingAttendance[language]}
                                    </span>
                                ) : session.attendance_status === "attended" ? (
                                    <span className="text-green-600">
                                        {content.attendedSession[language]}
                                    </span>
                                ) : (
                                    <span className="text-red-500">
                                        {content.missedSession[language]}
                                    </span>
                                )}
                            </div>
                            <div className="w-full">
                                {
                                    <p className="flex w-full gap-2">
                                        <label className="text-rose-500 font-semibold text-sm">
                                            {content.yourRating[language]}
                                        </label>
                                        {getOptionSingleText(
                                            sessionOptionsRate,
                                            session.live_session_user_rating
                                        )}
                                    </p>
                                }
                            </div>

                            {session.attendance_status === "attended" &&
                                session.admin_user_rating !== null && (
                                    <p className="flex flex-col w-full gap-2">
                                        <p className="flex w-full gap-2">
                                            <label className="text-rose-500 font-semibold text-sm">
                                                {content.assistantTeacher[language]}{" "}
                                            </label>
                                            <span className="text-sm">
                                                {session.live_session.admin.full_name}
                                            </span>
                                        </p>
                                        <p className="flex gap-2 w-full">
                                            <label className="text-rose-500 font-semibold text-sm ">
                                                {content.teacherRating[language]}{" "}
                                            </label>
                                            <span className="text-sm">
                                                {getOptionSingleText(
                                                    sessionOptionsRate,
                                                    session.admin_user_rating
                                                )}
                                            </span>
                                        </p>
                                        {session.admin_rated_at !== null && (
                                            <p className="flex items-center gap-1 w-full ">
                                                <label className="text-rose-500 font-semibold text-sm">
                                                    {content.ratingDate[language]}{" "}
                                                </label>
                                                <span className="w-1/2 text-center text-sm">
                                                    {printFullDateTime(session.admin_rated_at)}
                                                </span>
                                            </p>
                                        )}

                                        {session.admin_user_comment !== null && (
                                            <>
                                                <label className="text-rose-500 font-semibold text-sm">
                                                    {content.teacherComment[language]}{" "}
                                                </label>
                                                {
                                                    <span className="text-sm">
                                                        {session.admin_user_comment}
                                                    </span>
                                                }
                                            </>
                                        )}
                                    </p>
                                )}
                        </div>
                    </div>
                ) : (
                    ""
                )}
            </div>
            {session.attendance_status === "attended" ? (
                <SessionRateCard
                    data={data}
                    setData={setData}
                    handleRateSession={handleRateSession}
                    sessionId={session.id}
                />
            ) : session.attendance_status === "pending" ? (
                <p className="font-bold text-center">{content.waitingForSupervisor[language]}</p>
            ) : (
                <p className="font-bold text-center">{content.cannotRate[language]}</p>
            )}
        </div>
    );
};

export default LiveSessionUserAttendanceCard;
